import React from "react";

const EditIcon = () => {
  return (
    <svg
      width="26"
      height="28"
      viewBox="0 0 26 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="EditFilled">
        <path
          id="Vector"
          d="M3.49902 20.126V24.501H7.87402L20.7774 11.5976L16.4024 7.22263L3.49902 20.126ZM24.1607 8.2143C24.6157 7.7593 24.6157 7.0243 24.1607 6.5693L21.4307 3.8393C20.9757 3.3843 20.2407 3.3843 19.7857 3.8393L17.6507 5.9743L22.0257 10.3493L24.1607 8.2143Z"
          fill="#0075AA"
        />
      </g>
    </svg>
  );
};

export default EditIcon;
